import React from 'react';
import { CheckCircle2, ChevronRight, Plus } from 'lucide-react';

const TONOS = {
    brand: 'bg-brand/15 text-brand',
    azul: 'bg-sky-500/15 text-sky-400',
    verde: 'bg-emerald-500/15 text-emerald-400',
    ambar: 'bg-amber-500/15 text-amber-400',
    rosa: 'bg-pink-500/15 text-pink-400',
    violeta: 'bg-violet-500/15 text-violet-400',
    gris: 'bg-white/10 text-foreground/70',
};

/**
 * Tarjeta de una línea del Inicio: icono, título, una línea de estado y su acción.
 * `accion`: 'mas' (botón +), 'flecha' (›), o un texto corto que sale como píldora.
 */
const TarjetaInicio = ({ icono: Icono, tono = 'gris', titulo, detalle, accion = 'flecha', progreso = null,
                        hecho = false, onClick, testId }) => {
    const pulsable = typeof onClick === 'function';
    const Envoltura = pulsable ? 'button' : 'div';
    return (
        <Envoltura type={pulsable ? 'button' : undefined} onClick={onClick} data-testid={testId}
            className={`w-full text-left rounded-2xl border border-border bg-card p-4 flex items-center gap-4 transition-colors
                ${pulsable ? 'hover:border-foreground/25 group' : ''}`}>
            {Icono && (
                <span className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${TONOS[tono] || TONOS.gris}`}>
                    <Icono className="w-5 h-5" />
                </span>
            )}
            <span className="min-w-0 flex-1">
                <span className="block font-bold text-foreground text-[15px] leading-snug">{titulo}</span>
                {detalle && <span className="block text-sm text-muted-foreground mt-0.5 leading-snug">{detalle}</span>}
                {progreso != null && (
                    <span className="block h-1.5 rounded-full bg-white/10 overflow-hidden mt-2 max-w-[320px]">
                        <span className="block h-full rounded-full bg-brand transition-all" style={{ width: `${Math.min(100, progreso)}%` }} />
                    </span>
                )}
            </span>
            {hecho ? (
                <CheckCircle2 className="w-6 h-6 text-emerald-400 flex-shrink-0" />
            ) : accion === 'mas' ? (
                <span className="w-10 h-10 rounded-full bg-brand text-white flex items-center justify-center flex-shrink-0 shadow-lg shadow-brand/30 group-hover:brightness-110">
                    <Plus className="w-5 h-5" />
                </span>
            ) : accion === 'flecha' ? (
                pulsable && <ChevronRight className="w-5 h-5 text-muted-foreground group-hover:text-foreground flex-shrink-0" />
            ) : accion ? (
                <span className="px-3 py-1.5 rounded-lg bg-amber-500/15 text-amber-400 text-sm font-bold flex-shrink-0">{accion}</span>
            ) : null}
        </Envoltura>
    );
};

export default TarjetaInicio;
